// AppInsights.js
import {
  ApplicationInsights,
  ITelemetryItem,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

let reactPlugin: ReactPlugin;
let appInsights: ApplicationInsights;

const createAppInsightsService = () => {
  const initialize = async (instrumentationKey: string) => {
    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        autoTrackPageVisitTime: true,
        enableAutoRouteTracking: true,
        // Enable correlation
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: [
          "launchdarkly.com",
          "maps.googleapis.com"
        ],
        // End of correlation config
        // set ts ignore due to a pakcage issue that shouldn't affect anything
        // @ts-ignore
        extensions: [reactPlugin],
      },
    });

    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
      envelope.tags = envelope.tags || [];
      envelope.tags.push({ "ai.cloud.role": "SGI.VendorFinder.UI.UI" });
    });
    return { appInsights, reactPlugin };
  };
  return { initialize };
};

export const ai = createAppInsightsService();
export { appInsights, reactPlugin };
